import angular from 'angular';

export class SocialIntentsLiveChat {
    /* @ngInject */
    constructor($localStorage) {
        this.isSiChatEnabled = $localStorage.sysDefaults?.isSocialIntentsChatEnabled;
        if (this.isSiChatEnabled) {
            const script = document.createElement('script');
            script.setAttribute('type', 'text/javascript');
            script.setAttribute('id', 'si-script-loader');
            script.setAttribute('src', $localStorage.sysDefaults?.socialIntentsChatUrl || '//www.socialintents.com/api/chat/socialintents.1.3.js#2c9fa6c383edf8100183f073153c0191');
            document.head.appendChild(script);
        }
    }
}

export const SocialIntentsLiveChatConfiguration = {
    controller: SocialIntentsLiveChat,
    controllerAs: 'siChatCtrl',
};

angular.module('TALENYA-FE').component('siChat', SocialIntentsLiveChatConfiguration);
